export const FileStatus = {
    STATUS_UPLOAD_COMPLETE : "Upload complete",
    STATUS_UNABLE_TO_UPLOAD : "Unable to upload",
    STATUS_UNABLE_TO_PROCESS : "Unable to process",
    STATUS_PROCESSING: "Processing",
    STATUS_PROCESSING_COMPLETED: "Processing complete",
    STATUS_PARTIALLY_PROCESSED: "Partially processed",
    STATUS_PROCESSING_FAILED: "Processing failed"
}